import { create } from './create';
import { read } from './read';
import { readVerifyResults } from './readVerifyResults';

export default {
  read,
  create,
  readVerifyResults,
};
